<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>
    <li class="breadcrumb-item active" aria-current="page">
      {{ "Left_Menu.USER_MANAGEMENT" | translate }}
    </li>
    <li
      style="position: absolute; right: 39px"
      placement="left"
      ngbTooltip="Add User"
    >
      <div>
        <button
          style="padding: 3px"
          type="button"
          class="btn-shadow d-inline-flex align-items-center btn btn-primary px-2"
          (click)="open(content); userManagementId = null; onReset()"
        >
          <i class="fa fa-plus font-size-lg pt-1 text-white"></i>
        </button>
      </div>
    </li>
  </ol>
</nav>

<div class="main-card mb-3 card">
  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
    >
      <thead class="font-size-lg text-white">
        <tr>
          <th>{{ "Form.NAME" | translate }}</th>
          <th class="text-center">{{ "Form.EMAIL" | translate }}</th>
          <th>{{ "Form.STATUS" | translate }}</th>
          <th class="text-center">{{ "Form.ACTIONS" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let um of data">
          <td>
            <a (click)="toggleForm(um)">{{ um.username }}</a>
          </td>
          <td class="text-center">{{ um.email }}</td>
          <td>
            <mat-slide-toggle
              [(ngModel)]="um.status"
              [disabled]="true"
              class="custom-toggle"
            >
              {{
                um.status
                  ? ("Form.ENABLE" | translate)
                  : ("Form.DISABLE" | translate)
              }}
            </mat-slide-toggle>
          </td>
          <td class="text-center">
            <span
              mat-icon-button
              style="cursor: pointer"
              [matMenuTriggerFor]="menu"
              class="actions-icon-btn pt-3 pb-1 px-2 bg-transparent"
            >
              <mat-icon>more_vert</mat-icon>
            </span>

            <mat-menu #menu="matMenu" class="text-center">
              <button
                mat-menu-item
                (click)="open(content); toggleForm(um); currentUser = um"
              >
                <span
                  class="bg-transparent"
                  matTooltipPosition="right"
                  matTooltip="{{ 'Form.EDIT' | translate }}"
                >
                  <i
                    class="fa fa-pencil-square-o text-primary font-size-lg"
                    aria-hidden="true"
                  ></i>
                </span>
              </button>

              <button mat-menu-item (click)="openDeleteConfirmation(um)">
                <span
                  class="bg-transparent"
                  matTooltip="{{ 'Form.DELETE' | translate }}"
                  matTooltipPosition="right"
                >
                  <i
                    class="fa fa-trash-o text-danger font-size-lg"
                    aria-hidden="true"
                  ></i>
                </span>
              </button>
            </mat-menu>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="add-edit-user">
  <!-- <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Modal title</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Modal body text goes here.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary">Save changes</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div> -->

  <ng-template
    #content
    let-modal
    class="main-card mb-3 col-md-6 col-xl-4 mx-auto card add-edit-user"
  >
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" *ngIf="userManagementId">
        {{ "Form.UpdateUser" | translate }}
      </h4>
      <h4 class="modal-title" id="modal-basic-title" *ngIf="!userManagementId">
        {{ "Form.ADDUser" | translate }}
      </h4>

      <button
        type="button"
        (click)="
          modal.dismiss('Cross click'); userManagementId = null; onReset()
        "
      >
        &times;
      </button>
    </div>
    <div class="modal-body">
      <div class="">
        <div class="card-body pt-0 ps-1">
          <form [formGroup]="form" class="needs-validation">
            <div class="position-relative row form-group mb-2">
              <label for="name_Id" class="col-sm-12 col-form-label"
                >{{ "Form.NAME" | translate }}
                <span class="text-danger">*</span></label
              >
              <div class="col-sm-12">
                <input
                  formControlName="username"
                  name="username"
                  id="name_Id"
                  placeholder="{{ 'Form.Placeholder.USER_NAME' | translate }}"
                  type="text"
                  class="form-control"
                  required
                />
                <div
                  *ngIf="submitted && f.username.errors"
                  class="invalid-feedback"
                >
                  <div *ngIf="f.username.errors.required">
                    {{ "Form.Error.NAME" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="position-relative row form-group mb-2">
              <label for="email_id" class="col-sm-12 col-form-label"
                >{{ "Form.EMAIL" | translate }}
                <span class="text-danger">*</span></label
              >
              <div class="col-sm-12">
                <input
                  formControlName="email"
                  name="email"
                  id="email_id"
                  placeholder="{{ 'Form.Placeholder.EMAIL' | translate }}"
                  type="text"
                  class="form-control"
                  [readonly]="userManagementId ? true : false"
                  required
                />
                <div
                  *ngIf="submitted && f.email.errors"
                  class="invalid-feedback"
                >
                  <div *ngIf="f.email.errors.required">
                    {{ "Form.Error.EMAIL" | translate }}
                  </div>
                  <div
                    *ngIf="
                      f.email.errors.email || f.email.errors.noDotInUsername
                    "
                  >
                    {{ "Form.Error.InvalidEmail" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="position-relative row form-group mb-2">
              <label for="phone_id" class="col-sm-12 col-form-label">{{
                "Form.STATUS" | translate
              }}</label>
              <div class="col-sm-12">
                <mat-slide-toggle
                  [(ngModel)]="state"
                  [ngModelOptions]="{ standalone: true }"
                  (change)="onChange($event)"
                  class="custom-toggle"
                >
                  {{
                    state
                      ? ("Form.ENABLE" | translate)
                      : ("Form.DISABLE" | translate)
                  }}
                </mat-slide-toggle>
              </div>
            </div>

            <div class="position-relative row form-group mb-2">
              <label for="role_id" class="col-sm-12 col-form-label"
                >{{ "Form.ROLE" | translate }}
                <span class="text-danger">*</span></label
              >
              <div class="col-sm-12 col-md-10">
                <div class="form-group row m-1 p-1">
                  <div class="ps-3 col-md-1">
                    <input
                      class="form-check"
                      type="checkbox"
                      [checked]="isWriter"
                      (change)="onWriterChange()"
                    />
                  </div>
                  <label
                    class="col-md-5"
                    for="val-currency"
                    style="padding-top: 0"
                  >
                    <span>{{ "Form.Writer" | translate }}</span>
                  </label>
                </div>
                <div class="form-group row m-1 p-1">
                  <div class="ps-3 col-md-1">
                    <input
                      class="form-check"
                      type="checkbox"
                      [checked]="isReviewer"
                      (change)="onReviewerChange()"
                    />
                  </div>
                  <label
                    class="col-md-5"
                    for="val-currency"
                    style="padding-top: 0"
                  >
                    <span>{{ "Form.Reviewer" | translate }}</span>
                  </label>
                </div>
                <div class="form-group row m-1 p-1">
                  <div class="ps-3 col-md-1">
                    <input
                      class="form-check"
                      type="checkbox"
                      [checked]="isPublisher"
                      (change)="onPublisherChange()"
                    />
                  </div>
                  <label
                    class="col-md-5"
                    for="val-currency"
                    style="padding-top: 0"
                  >
                    <span>{{ "Form.Publisher" | translate }}</span>
                  </label>
                </div>
                <div class="form-group row m-1 p-1">
                  <div class="ps-3 col-md-1">
                    <input
                      class="form-check"
                      type="checkbox"
                      [checked]="isAdmin"
                      (change)="onAdminChange()"
                    />
                  </div>
                  <label
                    class="col-md-5"
                    for="val-currency"
                    style="padding-top: 0"
                  >
                    <span>{{ "Form.Administrator" | translate }}</span>
                  </label>
                </div>
                <div class="form-group row m-1 p-1">
                  <div class="ps-3 col-md-1">
                    <input
                      class="form-check"
                      type="checkbox"
                      [checked]="isTranslator"
                      (change)="onTranslatorChange()"
                    />
                  </div>
                  <label
                    class="col-md-5"
                    for="val-currency"
                    style="padding-top: 0"
                  >
                    <span>{{ "Form.Translator" | translate }}</span>
                  </label>
                </div>
                <div
                  *ngIf="submitted && showRoleError"
                  style="
                    width: 100%;
                    margin-top: 0.25rem;
                    font-size: 80%;
                    color: #e02b1d;
                  "
                >
                  {{ "Form.Error.RoleRequired" | translate }}
                </div>
              </div>
            </div>

            <div
              class="position-relative row form-check modal-footer text-center justify-content-start"
            >
              <div class="col-sm-10">
                <button
                  class="btn btn-primary btn-lg px-5 font-size-lg"
                  style="margin-right: 10px"
                  type="submit"
                  (click)="onSubmit()"
                >
                  {{ "Form.SAVE" | translate }}
                </button>
                <button
                  class="btn btn-secondary btn-lg text-white font-size-lg"
                  (click)="onReset(); modal.dismiss('Cross click')"
                >
                  {{ "Form.CANCEL" | translate }}
                </button>
              </div>
            </div>
          </form>

          <!-- <div class="relevent-info mt-5 pe-3">
            <div class="">
              <h3 class="mb-4">{{ "Form.ADDITIONALINFO" | translate }}</h3>
              <p>{{ "Form.ADDITIONALINFOUserManagement" | translate }}</p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </ng-template>
</div>
